import { Button } from '@ksyos/design-system';
import type { IStepProps } from '../NewGhcRequest';
import { ChapterTitle } from '../../../elements/atoms/chapterTitle/ChapterTitle';
import { Icon, IconColor } from '../../../elements/atoms/icon/Icon';
import { Paragraph } from '../../../elements/atoms/paragraph/Paragraph';
import { Article } from '../../../elements/molecules/article/article';
import { PageSection } from '../../../elements/molecules/pageSection/PageSection';

export function RequestSentMessage(props: IStepProps) {
    return (
        <PageSection
            align="center"
            bgColor="white"
        >
            <Article>
                <Icon
                    color={IconColor.success}
                    icon="checked"
                    size="xlarge"
                />
                <ChapterTitle>Je antwoorden zijn verzonden</ChapterTitle>
                <Paragraph>
                    Je huisarts gaat jouw antwoorden bekijken. De huisarts zal je bellen om jouw situatie te bespreken.
                    Houd daarom je telefoon bij de hand.
                </Paragraph>
                {props.request.customControlData.email && (
                    <Paragraph>
                        Het antwoord van de zorgverlener ontvang je op {props.request.customControlData.email}.
                    </Paragraph>
                )}
                <Button
                    onClick={() => (window.location.href = '/')}
                    type="button"
                    variant="solid"
                >
                    Terug naar Home
                </Button>
            </Article>
        </PageSection>
    );
}
